import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetReasonsForJoining = () => {
    const {
        isFetching: isLoading, data: reasons, error,
    } = useQuery({
        queryKey: ["ReasonsForJoining"],
        queryFn: () => axiosManager.get$("/parent/api/ReasonsForJoining").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const reasonsOptions = (reasons || []).map((item) => ({ value: item.reason, label: item.reason }));

    return {
        isLoading, reasons, error, reasonsOptions,
    };
};
